/**
 * Creates the final url to use in the http request
 */
export function serverUrlComposer(subpath: string): string {
   return `${process.env.REACT_APP_SERVER_URL}${process.env.REACT_APP_API_PATH}${subpath}`;
}
